export default {
  confirm: {
    id: 'buyback_funnel_checkbox_confirm',
    defaultMessage: 'Confirm',
  },
  noneOfThese: {
    id: 'buyback_funnel_checkbox_none_of_these',
    defaultMessage: 'Neither of these work',
  },
}
